import React, { useCallback } from "react";
import * as Request from "superagent";
import { formatMoney, formatNumber } from "accounting";
import { ApiBasePath } from "../../utils/ApiBasePath";

interface Props {}
interface State {
  disclaimerInfo: DisclaimerInfo;
  isGfv: boolean;
  isFinanceFormInputPersonalised: boolean;
}

export class Disclaimers extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = {
      disclaimerInfo: null,
      isGfv: false,
      isFinanceFormInputPersonalised: false,
    };
  }

  getFinanceSimulationByVariantId(
    variantId: string,
    successCallback: (response: Request.Response) => any,
    failureCallback: (error: any) => any
  ) {
    const url = `${ApiBasePath.finance}`;
    let financeFormInput = null;
    if (localStorage.getItem("au_sub-dis_finance_form_input")) {
      const storedInput = JSON.parse(
        localStorage.getItem("au_sub-dis_finance_form_input")
      );
      // Only use stored input if paymentType is 'finance'
      if (storedInput && storedInput.paymentType === 'finance') {
        financeFormInput = storedInput;
      }
    }
    if (financeFormInput === null) {
      financeFormInput = {
        paymentType: "finance",
        financeProductId: "FIN_PROD_AUS_SUB_GFV",
        mileage: 15000,
        financePackageId: "Weekly",
        deposit: 0,
        term: 60,
        ageRange: "23",
        homeOwner: "true",
        creditRating: "VERY_GOOD",
      };
    }
    const variables = {
      codes: [variantId],
      financeFormInput: financeFormInput,
      postCode: this.getSavedPostcode(),
    };
    Request.post(url)
      .set("Content-Type", "application/json")
      .send(JSON.stringify(variables))
      .then((ret) => {
        successCallback(ret);
      }, failureCallback);
  }

  getSavedPostcode(): string {
    var savedCookie = localStorage.getItem("suburb");
    if (savedCookie) {
      let stateSelection = JSON.parse(savedCookie);
      if (!stateSelection.postcode) {
        stateSelection.postcode = "2000";
      }
      let postcode = stateSelection.postcode.toString();

      if (postcode.length === 3) {
        postcode = "0".concat(postcode);
      }
      return postcode;
    } else {
      return "2000";
    }
  }

  componentDidMount() {
    window.addEventListener("tabChanged", (e: any) => {
      //resetting gfv status
      this.setState({
        isGfv: false,
      });
    });
    window.addEventListener("repaymentInfoUpdated", (e: any) => {
      if(e.detail) {
        const disclaimerInfo: DisclaimerInfo = {
          deposit: e.detail.deposits[0].value / 100,
          term: e.detail.loanTermPeriod.value,
          comparisonRate: e.detail.comparisonRate,
          indicativeInterestRate: e.detail.interestRate,
          mileage: e.detail.mileage,
        };
        this.setState({
          disclaimerInfo,
          isFinanceFormInputPersonalised:
            e.detail.isFinanceFormInputPersonalised,
        });
        this.setState({
          isGfv: e.detail.financeProduct === "FIN_PROD_AUS_SUB_GFV",
        });
      }
    });
  }

  render() {
    //hide on Configurator's configure page. i.e. last step of the configurator
    const toShow = !window.location.pathname.startsWith("/configure/configure");
    return (
      toShow &&
      this.state.disclaimerInfo != null && (
        <section className="disclaimers">
          <div className="container">
            <hr className="footer-copyright-line"></hr>
            <div className="disclaimers_header">Finance Disclaimers</div>
            {this.state.isGfv && (
              <p>
                1. The Guaranteed Future Value (GFV) is the minimum future value
                of your vehicle as determined by Subaru Financial Services (SFS)
                and set out in your contract. At the end of the term, you can
                select from three options: (1) sell or trade in the vehicle and
                repay your loan balance; (2) return the vehicle to us; or (3)
                retain the vehicle by paying the GFV amount, which is a lump sum
                amount owed to us at the end of the loan term. Total interest
                payable on the loan will be higher than a loan with no GFV.
                Monthly repayments will be lower compared to a similar loan term
                with no GFV or no equivalent balloon final payment. Available on
                new and demonstrator Subaru vehicles for selected models only.
                Vehicle eligibility is subject to change. If you decide to
                return your car at the end of your term, SFS, or another person
                or entity with SFS&apos;s agreement will purchase the vehicle
                from you for the GFV, which will be applied to reduce your
                outstanding loan amount. However, you will need to pay us an
                additional amount if the vehicle is damaged or you have
                travelled excess kilometres. Terms, conditions, fees and charges
                apply. Approved applicants only.
              </p>
            )}
            <p>
              2. Finance to approved applicants only. These repayments are for
              indicative use only. No result from the use of the calculator
              should be considered a loan application or an offer of a loan. The
              estimated repayment amount is based on a secured Consumer Loan
              with a {this.state.disclaimerInfo.term} month term
              {this.state.isGfv
                ? ", a " +
                  formatNumber(this.state.disclaimerInfo.mileage) +
                  " annual km allowance"
                : ""}
              ,{" "}
              {formatNumber(
                this.state.disclaimerInfo.indicativeInterestRate,
                2
              )}
              % p.a. indicative interest rate with a{" "}
              {formatMoney(this.state.disclaimerInfo.deposit, {
                symbol: "$",
                precision: 0,
              })}{" "}
              deposit
              {this.state.isGfv
                ? " and the displayed Guaranteed Future Value amount. "
                : ". "}
              Repayments must be made fortnightly or monthly and cannot be made
              weekly. Dealer commission, standard fees and charges apply. Before
              making a decision about any of the products and services featured
              on this website, you should consult with your own independent
              legal, taxation and financial advisors, who can advise you about
              your personal circumstances.
            </p>
            <p>
              4.{" "}
              {this.state.isFinanceFormInputPersonalised
                ? "These indicative rates are based on the loan type and the details selected. Changing your details or the details of the loan may change these rates. Rates are subject to change without notice. "
                : "Most of our property owner customers qualify for the advertised comparison rate or better. The actual comparison rate offered to you may vary based on factors including your credit score, loan amount, term and property ownership status. "}
              The comparison rate is based on a secured consumer fixed rate loan
              of $30,000 over a term of 5 years. WARNING: This comparison rate
              is true only for the examples given and may not include all fees
              and charges. Different terms, fees or other loan amounts might
              result in a different comparison rate. Finance is provided by IFSA
              Pty Ltd ABN 39 651 319 774 trading as Subaru Financial Services,
              managed by Allied Retail Finance Pty Ltd ABN 31 609 859 985
              Australian credit licence 483211.
            </p>
            <p>
              (i) Comparison Rate
              <br />
              The comparison rate includes your loan&apos;s interest rate - plus
              other fees and charges relating to your loan - and expresses the
              combined amount as a percentage figure to determine the true cost
              of your loan. Estimates are indicative only. This indicative
              estimate has been provided to assist you with calculating what
              your repayments may be and does not constitute an offer capable of
              acceptance. Rates are subject to the accuracy of the information
              provided by you, the outcome of the assessment of your
              application, and changes in base rates. Any changes to the loan
              details may result in a different interest rate. The actual rate
              applied and repayment amount will be confirmed in the finance
              documentation if your application is approved. Fees and charges
              are payable. Full terms and conditions are available on request.
            </p>
          </div>
        </section>
      )
    );
  }
}

export interface DisclaimerInfo {
  deposit: number;
  term: string;
  mileage: number;
  comparisonRate: number;
  indicativeInterestRate: number;
}
